import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import Colours from '../../../../style_helpers/colours'

function Loader (props) {
  const rectBaseStyle = styles.loader.rect(props.colour)
  return (
    <b style={styles.loader.base}>
      <div style={{ ...rectBaseStyle, ...styles.loader.rect1 }} />
      <div style={{ ...rectBaseStyle, ...styles.loader.rect2 }} />
      <div style={{ ...rectBaseStyle, ...styles.loader.rect3 }} />
      <div style={{ ...rectBaseStyle, ...styles.loader.rect4 }} />
    </b>
  )
}

Loader.defaultProps = {
  colour: Colours('white', '300')
}

Loader.propTypes = {
  colour: PropTypes.string
}

export default Loader
